import script from "./ResourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceCard.vue?vue&type=script&setup=true&lang=js"

import "./ResourceCard.vue?vue&type=style&index=0&id=5bea4ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bea4ad4"]])

export default __exports__